import React, { Component } from "react";

class Staterfarge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pris: this.props.pris2,
      farge: "Messingfarget",
      activeSvart: false,
      activeMessing: true,
      active37: false,
      knapp: this.props.mppid2,
    };

    this.handleClickSvart = this.handleClickSvart.bind(this);
    this.handleClickMessing = this.handleClickMessing.bind(this);
  }

  handleClickSvart(e) {
    console.log("Clicked 26");
    this.props.handleChildChange("Black");
    this.setState({
      pris: this.props.pris1,
      farge: "Svart farge",
      activeSvart: true,
      activeMessing: false,
      knapp: this.props.mppid1,
    });
  }

  handleClickMessing(e) {
    console.log("Clicked 31");
    this.props.handleChildChange("Brass");
    this.setState({
      pris: this.props.pris2,
      farge: "Messingfarget",
      activeSvart: false,
      activeMessing: true,
      knapp: this.props.mppid2,
    });
  }

  render() {
    return (
      <div>
        <div>
          {this.state.activeSvart === true ? (
            <button onClick={this.handleClickSvart} className="btn btn-dark text-light mr-2 mb-2">
              Svart
            </button>
          ) : (
            <button onClick={this.handleClickSvart} className="btn btn-outline-secondary mr-2 mb-2">
              Svart
            </button>
          )}
          {this.state.activeMessing === true ? (
            <button onClick={this.handleClickMessing} className="btn btn-warning mr-2 mb-2">
              Messing
            </button>
          ) : (
            <button onClick={this.handleClickMessing} className="btn btn-outline-secondary mr-2 mb-2">
              Messing
            </button>
          )}
          <h3>{this.state.pris}</h3>
          {this.state.farge}
          <a href={this.state.knapp} className="btn btn-block btn-lg btn-success mt-4 mr-4">
            Kjøp nå
          </a>
        </div>
      </div>
    );
  }
}

export default Staterfarge;
